export enum TABLE_VARIANTS {
  LIGHT = 'LIGHT',
  DARK = 'DARK',
}
